"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PromoteReplyToNewTopicModal", {
  enumerable: true,
  get: function get() {
    return _PromoteReplyToNewTopicModal.default;
  }
});

var _PromoteReplyToNewTopicModal = _interopRequireDefault(require("./PromoteReplyToNewTopicModal"));